import { render, staticRenderFns } from "./Finish.vue?vue&type=template&id=49e07dc3&"
import script from "./Finish.vue?vue&type=script&lang=js&"
export * from "./Finish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49e07dc3')) {
      api.createRecord('49e07dc3', component.options)
    } else {
      api.reload('49e07dc3', component.options)
    }
    module.hot.accept("./Finish.vue?vue&type=template&id=49e07dc3&", function () {
      api.rerender('49e07dc3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/Onboarding/Components/Finish.vue"
export default component.exports